export default __webpack_public_path__ + "static/media/interview.9855b942.svg";